<form #formRef="ngForm">
	<bb-page-header [backOnMobile]="['/library/playouts']" [icon]="'sliders'" [tabItems]="tabItems" [title]="entity?.name">

		<span class="subtitle"> {{ entity?.label }} </span>

		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [valueOn]="'active'" [valueOff]="'inactive'" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate"></bb-status>

	</bb-page-header>

	<div *ngIf="entity" class="body-column" [ngClass]="{'tab-container': activeTab !== 'advertising'}" cdkScrollable>
		<playout-details-appearance *ngIf="tabLoadedBefore('appearance')" [form]="form" [playout]="entity" [playerApi]="playerApi" [usedColors]="usedColors" [hidden]="activeTab !== 'appearance'"></playout-details-appearance>
		<playout-details-controlbar *ngIf="tabLoadedBefore('controlbar')" [form]="form" [playout]="entity" [hidden]="activeTab !== 'controlbar'" (playoutUpdated)="onPlayoutUpdated($event)"></playout-details-controlbar>
		<playout-details-sharing *ngIf="tabLoadedBefore('sharing')" [form]="form" [playout]="entity" [previewPlayer]="playerApi" [hidden]="activeTab !== 'sharing'"></playout-details-sharing>
		<playout-details-start-endscreen *ngIf="tabLoadedBefore('start-end-screen')" [form]="form" [playout]="entity" [previewPlayer]="playerApi" [hidden]="activeTab !== 'start-end-screen'"></playout-details-start-endscreen>
		<playout-details-advertising *ngIf="adServicesRight && tabLoadedBefore('advertising')" [form]="form" [playout]="entity" [hidden]="activeTab !== 'advertising'"></playout-details-advertising>
		<playout-details-viewpage *ngIf="tabLoadedBefore('viewpage')" (updateViewpage)="viewpagePreviewChanged($event)" [form]="form" [playout]="entity" [usedColors]="usedColors" [hidden]="activeTab !== 'viewpage'"></playout-details-viewpage>
		<bb-fitmode *ngIf="tabLoadedBefore('fitmode')" [screen]="'playoutDetails'" [form]="form" [(entity)]="entity" [hidden]="activeTab !== 'fitmode'"></bb-fitmode>
		<playout-details-miscellaneous *ngIf="tabLoadedBefore('miscellaneous')" [form]="form" [playout]="entity" [hidden]="activeTab !== 'miscellaneous'" (resetVideo)="resetVideo()"></playout-details-miscellaneous>
		<playout-details-behaviour *ngIf="tabLoadedBefore('behaviour')" [form]="form" [formGroup]="formGroup" [playout]="entity" [hidden]="activeTab !== 'behaviour'"></playout-details-behaviour>
	</div>

	<div *ngIf="activeTab === 'viewpage'" class="body-column preview-container viewpage-preview">
		<div class="iframe_wrapper"><div class="iframe_dummy"></div><iframe [src]="viewpagePreviewUrl"></iframe></div>

		<button class="button" (click)="openViewpage()"><i class="fa fa-external-link"></i> {{'OPEN_IN_NEW_PAGE' | translate}}</button>
		<button class="button" (click)="refreshViewpagePreview()"><i class="fa fa-refresh"></i> {{'REFRESH_VIEWPAGE_PREVIEW' | translate}}</button>
	</div>

	<div *ngIf="activeTab !== 'advertising' && activeTab !== 'viewpage'" class="body-column preview-container">
		<h3 class="mobile">{{'PREVIEW' | translate}}</h3> 
		<div
			class="message warning" *ngIf="entity?.customSkinPath && entity.customSkinPath !== 'https://d1i254ftm0zvcw.cloudfront.net/apps/skins/v6.40.0-old/'">
			<i class="fa fa-warning"></i> {{'USING_CUSTOM_SKIN_WARNING' | translate}}
		</div>
		<div class="preview-wrapper" [style.aspect-ratio]="entity?.aspectRatio?.replace(':','/') || '16 / 9'">
			<div *ngIf="demoMediaclip && entity && !reloadPlayer">
				<bb-player
					[allowPlayerRefresh]="true"
					[mediaclip]="demoMediaclip"
					(onPlayerCreated)="playerCreated($event)"
					[inheritDimensions]="true"
					[autoplay]="false"
					[playout]="previewPlayout"></bb-player>
			</div>
		</div>

		<div class="preview-buttons">
			<bb-button (click)="resetVideo()">
				{{ 'RESET_PLAYER' | translate }}
			</bb-button>
			<div class="buttons-right">
				<bb-button [active]="format === '4:3'" (click)="updatePlayerDimensions('4:3')">
					{{ '4_3_EXAMPLE' | translate }}
				</bb-button>
				<bb-button [active]="format === '16:9'" (click)="updatePlayerDimensions('16:9')">
					{{ '16_9_EXAMPLE' | translate }}
				</bb-button>
				<bb-button [active]="format === '21:9'" (click)="updatePlayerDimensions('21:9')">
					{{ '21_9_EXAMPLE' | translate }}
				</bb-button>
			</div>
		</div>
		<bb-entity-details
			[entity]="entity"
		></bb-entity-details>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form" [entity]="entity"></bb-actions-bar>
